import { PseudoPostType } from 'constants/post';
import { canAcceptAttachmentsFromPseudoType } from './helpers';
import { AttachmentsHandlerFunction } from './types';
import { AttachmentCardMedium, AttachmentCards } from 'types/Attachments';

export const processPhotoAttachments =
  ({
    acceptedPseudoTypes = [
      PseudoPostType.Gallery,
      PseudoPostType.Carousel,
      PseudoPostType.PhotoGallery,
    ],
  }: {
    acceptedPseudoTypes?: PseudoPostType[];
  }) =>
  ({
    form,
    pseudoPost,
    attachmentsByPseudoType,
  }: AttachmentsHandlerFunction) => {
    const photoPseudoPost = PseudoPostType.Photo;
    let attachmentCards: AttachmentCards<AttachmentCardMedium> =
      attachmentsByPseudoType[photoPseudoPost]?.cards ?? [];

    const canAccept = canAcceptAttachmentsFromPseudoType({
      pseudoTypes: acceptedPseudoTypes,
      pseudoPost: pseudoPost.key,
      attachmentsByPseudoType,
    });

    if (canAccept) {
      if (form.pseudoType === photoPseudoPost) {
        const hasUploadedPhoto = form.attachments?.cards?.length > 0;
        if (hasUploadedPhoto) {
          attachmentCards = form.attachments?.cards ?? [];
        }
      }
      return attachmentCards;
    }
    return attachmentsByPseudoType[pseudoPost.key]?.cards ?? [];
  };
